import axios from 'axios';
import { ApolloClient, InMemoryCache } from '@apollo/client';
import { ENV } from '../constants';

const rest = axios.create({
  baseURL: ENV.REACT_APP_CMS_HOST || 'http://localhost:3333', // 'http://23.22.89.145:87',
  headers: {
    'x-tenant-id': ENV.REACT_APP_TENANT_ID,
  },
});

rest.interceptors.response.use(
  response => response,
  error => {
    if (error?.response?.status === 401) {
      localStorage.clear();
      delete rest.defaults.headers.common.authorization;
      window.location.href = '/';
    }
    return Promise.reject(error);
  },
);

const graphql = new ApolloClient({
  uri: ENV.REACT_APP_CMS_GRAPHQL_HOST || 'http://localhost:3333/graphql', // 'http://23.22.89.145:87',
  cache: new InMemoryCache(),
  headers: {
    'x-tenant-id': ENV.REACT_APP_TENANT_ID,
  },
});

export default { rest, graphql };
